import * as Sentry from "@sentry/react";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import AppRoutes from "./routes/AppRoutes";
import { ToastProvider } from "./components/ToastContext";
import ToastContainer from "./components/Toast";
import CyberBackground from "./components/common/CyberBackground";

function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={<div>Something went wrong</div>}
      showDialog={false}
    >
      <ThemeProvider>
        <AuthProvider>
          <ToastProvider>
            <CyberBackground />
            <AppRoutes />
            <ToastContainer />
          </ToastProvider>
        </AuthProvider>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  );
}

export default App;
